import { Loader, SkeletonLoader } from '@kanda-libs/ks-design-library';
import { FunctionComponent } from 'react';

import { URLS } from 'config';
import { useGoogleSignIn } from 'hooks';
import GoogleLogo from './g-logo.png';

export interface GoogleSignInButtonProps {
  successUrl?: string;
}

const GoogleSignInButton: FunctionComponent<GoogleSignInButtonProps> =
  function ({ successUrl = URLS.home }) {
    const { isSubmitting, disabled, signInWithGoogle } =
      useGoogleSignIn(successUrl);
    return (
      <div className="flex w-60">
        <SkeletonLoader
          width="100%"
          height={44}
          wrapperClassName="w-full"
          afterLoading={
            <button
              className="relative flex flex-row w-full h-12 p-3 rounded font-roboto social-shadow rounded-3xl bg-neutral-000"
              type="button"
              id="google-staff-login-quote"
              disabled={disabled || isSubmitting}
              onClick={signInWithGoogle}
            >
              <img
                width={24}
                height={24}
                src={GoogleLogo}
                alt="g-logo"
                className="absolute w-6 h-6 left-2 top-1/2 transform -translate-y-1/2"
              />
              <p className="w-full my-auto text-center text-14-22 whitespace-nowrap">
                Sign in with Google
              </p>
            </button>
          }
        />
        <Loader isLoading={isSubmitting} />
      </div>
    );
  };

export default GoogleSignInButton;
